module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/groups/groups-delete/groups-delete.component.css
// module id = ./src/app/groups/groups-delete/groups-delete.component.css
// module chunks = main